'use client';

import { createContext, useContext } from 'react';

type ModalContextType = {
  setHeader: (header: React.ReactNode) => void;
};

export const ModalContext = createContext<ModalContextType | null>(null);

export const useModalContext = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error('useModalContext must be used within ModalContext.Provider');
  return ctx;
};
